export default "__VITE_ASSET__C$kKgk97__"